import styled from 'styled-components';
import BannerBG from 'common/src/assets/image/saasModern/banner-texture.png';

export const PageShell = styled.div`
  background: linear-gradient(180deg, #f5fbf8 0%, #ffffff 24%, #f7fafc 100%);
`;

export const HeroSection = styled.section`
  position: relative;
  overflow: hidden;
  padding: 170px 0 88px;
  background-image: url(${BannerBG}),
    radial-gradient(
      circle at top left,
      rgba(237, 205, 55, 0.18),
      transparent 32%
    ),
    linear-gradient(135deg, #16313c 0%, #224253 48%, #2aa275 100%);
  background-size: cover;
  background-position: center;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      145deg,
      rgba(255, 255, 255, 0.06) 0%,
      rgba(255, 255, 255, 0) 50%,
      rgba(255, 255, 255, 0.12) 100%
    );
    pointer-events: none;
  }

  @media (max-width: 767px) {
    padding: 140px 0 64px;
  }
`;

export const HeroGrid = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 0.95fr);
  gap: 40px;
  align-items: center;

  @media (max-width: 990px) {
    grid-template-columns: 1fr;
  }
`;

export const Eyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #edcd37;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

export const HeroTitle = styled.h1`
  margin: 22px 0 18px;
  max-width: 720px;
  color: #ffffff;
  font-size: clamp(40px, 6vw, 64px);
  line-height: 1.02;
  letter-spacing: -0.04em;

  @media (max-width: 767px) {
    font-size: 38px;
  }
`;

export const HeroText = styled.p`
  max-width: 640px;
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: 18px;
  line-height: 1.8;
`;

export const HeroActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 32px;
`;

const actionStyles = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  padding: 0 22px;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }
`;

export const PrimaryAction = styled.a`
  ${actionStyles}
  background: #edcd37;
  border: 1px solid #edcd37;
  color: #11212b;
  box-shadow: 0 18px 36px rgba(8, 27, 38, 0.24);

  &:hover {
    box-shadow: 0 22px 44px rgba(8, 27, 38, 0.28);
  }
`;

export const SecondaryAction = styled.a`
  ${actionStyles}
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #ffffff;
  backdrop-filter: blur(12px);
`;

export const HeroHighlights = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;

export const HighlightCard = styled.a`
  display: block;
  padding: 22px;
  border-radius: 24px;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(16px);
  box-shadow: 0 24px 60px rgba(8, 27, 38, 0.2);
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(237, 205, 55, 0.45);
  }
`;

export const HighlightLabel = styled.span`
  display: inline-block;
  margin-bottom: 10px;
  color: #edcd37;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
`;

export const HighlightTitle = styled.h2`
  margin: 0 0 8px;
  color: #ffffff;
  font-size: 22px;
  line-height: 1.2;
`;

export const HighlightText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 15px;
  line-height: 1.7;
`;

export const StickyNav = styled.div`
  position: sticky;
  top: 68px;
  z-index: 20;
  padding: 18px 0;
  backdrop-filter: blur(18px);
  background: rgba(255, 255, 255, 0.84);
  border-bottom: 1px solid rgba(21, 44, 56, 0.08);

  @media (max-width: 990px) {
    top: 64px;
  }
`;

export const StickyNavInner = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 4px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StickyNavLink = styled.a`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 0 18px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid rgba(25, 46, 59, 0.1);
  color: #214154;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    color: #1d7c5d;
    border-color: rgba(42, 162, 117, 0.35);
    box-shadow: 0 10px 24px rgba(33, 65, 84, 0.08);
  }
`;

export const Section = styled.section`
  padding: 88px 0;
  scroll-margin-top: 150px;

  @media (max-width: 767px) {
    padding: 72px 0;
    scroll-margin-top: 130px;
  }
`;

export const SectionIntro = styled.div`
  max-width: 720px;
  margin-bottom: 36px;
`;

export const SectionLabel = styled.span`
  display: inline-block;
  margin-bottom: 12px;
  color: #2aa275;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 14px;
  color: #10212f;
  font-size: clamp(30px, 4vw, 48px);
  line-height: 1.08;
  letter-spacing: -0.035em;
`;

export const SectionText = styled.p`
  margin: 0;
  color: #5b6975;
  font-size: 17px;
  line-height: 1.85;
`;

export const BrowserLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.75fr) minmax(0, 1.25fr);
  gap: 28px;

  @media (max-width: 990px) {
    grid-template-columns: 1fr;
  }
`;

export const BrowserAside = styled.div`
  padding: 28px;
  border-radius: 28px;
  background: linear-gradient(160deg, #103243 0%, #20445a 100%);
  color: #ffffff;
  box-shadow: 0 28px 54px rgba(17, 34, 49, 0.14);
`;

export const AsideTitle = styled.h3`
  margin: 0 0 14px;
  font-size: 28px;
  line-height: 1.2;
`;

export const AsideText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
`;

export const AsideList = styled.ul`
  margin: 24px 0 0;
  padding: 0;
  list-style: none;
`;

export const AsideListItem = styled.li`
  position: relative;
  margin-bottom: 14px;
  padding-left: 22px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.7;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 11px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #edcd37;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const BrowserList = styled.div`
  display: grid;
  gap: 16px;
`;

export const BrowserRow = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 18px;
  align-items: center;
  padding: 22px 24px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid rgba(18, 34, 48, 0.08);
  box-shadow: 0 18px 34px rgba(19, 36, 51, 0.05);

  @media (max-width: 767px) {
    grid-template-columns: auto 1fr;
  }
`;

export const BrowserBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 18px;
  background: linear-gradient(145deg, #e7f7f0 0%, #f7fbfd 100%);
  color: #1b7f60;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const BrowserTitle = styled.h3`
  margin: 0 0 6px;
  color: #10212f;
  font-size: 20px;
`;

export const BrowserMeta = styled.p`
  margin: 0 0 6px;
  color: #2aa275;
  font-size: 14px;
  font-weight: 700;
`;

export const BrowserDescription = styled.p`
  margin: 0;
  color: #62707d;
  line-height: 1.75;
`;

export const BrowserActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;

  @media (max-width: 767px) {
    grid-column: 1 / -1;
    justify-content: flex-start;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;

  @media (max-width: 990px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const DownloadCard = styled.article`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 28px;
  border-radius: 28px;
  background: #ffffff;
  border: 1px solid rgba(18, 34, 48, 0.08);
  box-shadow: 0 22px 42px rgba(19, 36, 51, 0.06);
`;

export const CardLabel = styled.span`
  display: inline-block;
  margin-bottom: 14px;
  color: #2aa275;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
`;

export const CardTitle = styled.h3`
  margin: 0 0 12px;
  color: #10212f;
  font-size: 24px;
  line-height: 1.2;
`;

export const CardText = styled.p`
  margin: 0;
  color: #62707d;
  line-height: 1.8;
`;

export const MobileCardTop = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 148px;
  gap: 20px;
  align-items: start;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;

export const QRPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const QRFrame = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 148px;
  height: 148px;
  padding: 12px;
  border-radius: 24px;
  background: linear-gradient(145deg, #f8fbfd 0%, #eaf3ef 100%);
  border: 1px solid rgba(18, 34, 48, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const QRHint = styled.p`
  margin: 0;
  color: #6c7884;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
  text-align: center;
`;

export const MobileActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
  padding-top: 22px;
`;

export const StoreBadgeButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 14px;
  min-height: 62px;
  width: fit-content;
  max-width: 100%;
  padding: 10px 18px;
  border-radius: 18px;
  background: #111111;
  border: 1px solid #111111;
  color: #ffffff;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 18px 32px rgba(17, 17, 17, 0.18);
  }
`;

export const StoreBadgeIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const StoreBadgeText = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const StoreBadgeEyebrow = styled.span`
  color: rgba(255, 255, 255, 0.78);
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
`;

export const StoreBadgeLabel = styled.span`
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
`;

export const TextAction = styled.a`
  color: #1c7d5f;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  text-decoration: none;

  &:hover {
    color: #103243;
  }
`;

export const Snippet = styled.code`
  display: block;
  margin-top: 18px;
  padding: 14px 16px;
  overflow-x: auto;
  white-space: pre-wrap;
  border-radius: 18px;
  background: #0f2330;
  color: #dff8ef;
  font-family: 'Roboto Mono', 'SFMono-Regular', Consolas, monospace;
  font-size: 13px;
  line-height: 1.7;
`;

export const CardFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: auto;
  padding-top: 22px;
`;

export const TertiaryNote = styled.p`
  margin: 16px 0 0;
  color: #7a8792;
  font-size: 14px;
  line-height: 1.7;
`;

export const InlineAction = styled.a`
  ${actionStyles}
  min-height: 46px;
  padding: 0 18px;
  background: #103243;
  border: 1px solid #103243;
  color: #ffffff;
  box-shadow: none;
`;

export const InlineGhostAction = styled.a`
  ${actionStyles}
  min-height: 46px;
  padding: 0 18px;
  background: #ffffff;
  border: 1px solid rgba(18, 34, 48, 0.1);
  color: #214154;
  box-shadow: none;
`;

export const SpotlightCard = styled.div`
  padding: 34px;
  border-radius: 32px;
  background: linear-gradient(145deg, #ffffff 0%, #eef7f2 100%);
  border: 1px solid rgba(42, 162, 117, 0.12);
  box-shadow: 0 28px 56px rgba(25, 44, 58, 0.08);
`;

export const SpotlightActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
`;

export const FooterCallout = styled.div`
  margin-top: 32px;
  padding: 30px;
  border-radius: 28px;
  background: linear-gradient(145deg, #102d3a 0%, #1b4154 100%);
  color: #ffffff;
`;

export const FooterCalloutTitle = styled.h3`
  margin: 0 0 10px;
  font-size: 28px;
  line-height: 1.2;
`;

export const FooterCalloutText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
`;

export const FooterCalloutActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
`;
